import script from "./goodsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsDetails.vue?vue&type=script&setup=true&lang=js"

import "./goodsDetails.vue?vue&type=style&index=0&id=8251c056&lang=scss&scoped=true"
import "./goodsDetails.vue?vue&type=style&index=1&id=8251c056&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8251c056"]])

export default __exports__